export default "__VITE_ASSET__B8RUsHWl__"